var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 7h10a1 1 0 010 2H5v3L0 8l5-4v3zM8 3h7a1 1 0 000-2H8a1 1 0 000 2zm0 12h7a1 1 0 000-2H8a1 1 0 000 2z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik01IDdoMTBhMSAxIDAgMDEwIDJINXYzTDAgOGw1LTR2M3oiLz48cGF0aCBkPSJNOCAzaDdhMSAxIDAgMDAwLTJIOGExIDEgMCAwMDAgMnpNOCAxNWg3YTEgMSAwIDAwMC0ySDhhMSAxIDAgMDAwIDJ6Ii8+PC9nPjwvc3ZnPgo=";
export { SvgSlideLeft as ReactComponent };